module.exports = __webpack_public_path__ + "img/speaker.213247ff.webp";